export default {
  button: {
    cancel: 'Annuler',
    confirm: 'Confirmer',
    add: 'Ajouter',
    settings: 'Propriétés',
    back: 'Retour',
    next: 'Suivant',
    edit: 'Modifier',
    finish: 'Terminer',
    preview: 'Aperçu',
    deselect: 'Désélectionner',
    select: 'Sélectionner',
    validate: 'Valider',
    ecran: '+ Écran',
    search: 'Rechercher',
    exit: 'Quitter',
  },
  tabs: {
    screens: 'Liste des écrans',
    dispositions: 'Liste des dispositions',
    models: 'Modèles',
    recents: 'Récent',
    images: 'Images',
    videos: 'Vidéos',
    empty: 'Disposition vierge',
  },
  panels: {
    selectedScreen: ' écran(s) séléctionné(s)',
    addNewScreen: 'Ajouter un écran',
    addNewSegment: 'Ajouter un segment',
    newSegment: 'Nouveau segment',
    deleteScreen: 'Supprimer',
    duplicateScreen: 'Dupliquer un écran',
    duplicateSegment: 'Dupliquer un segment',
    screenSettings: "Paramètres de l'écran",
    editScreen: 'Modifier un écran',
    edit_title: 'Modifier le titre',
    title: 'Titre',
    duration: 'Durée',
    infos: {
      title: 'Informations',
      name_segment: ' Nom de segment:',
      duration_segment: ' Durée de segment:',
      duration_total: ' Durée totale des écrans:',
      name_template: 'Nom de template:',
      duration_template: 'Durée de template:',
      size_template: 'Taille de template:',
      name_screen: "Nom de l'écran:",
      duration_screen: "Durée de l'écran:",
    },
  },
  modal: {
    reclamation_title: 'Envoyer des commentaires',
    reclamation_placeholder: 'Décrivez le problème.',
    about: 'A propos',
    error: 'Message Erorr',
    okText: 'Continuer',
    cancelText: 'Annuler',
    verifDuration: 'La durée des écrans est supérieure à celle de la template',

    delete: {
      title: 'Voulez vous vraiment supprimer?',
      confirm_title: 'Supprimé',
      confirm_msg: 'La suppression est effectuée avec succès.',
      cancel_title: 'Annuler',
      cancel_msg: 'Vous avez annulé la suppression',
      btn_confirm: 'Oui',
      btn_cancel: 'Non',
    },
    edit: {
      title: 'Modifier le titre de cet écran',
      error_msg: 'Entrer un nom',
      btn_confirm: 'Modifier',
      btn_cancel: 'Annuler',
    },
    setting: {
      title: 'Paramètres',
      layers: 'Couches',
      effects: ' Effets',
      opacity: 'Opacité',
      delay: 'Retard(ms)',
      animation: {
        title: 'Animation',
        grow: 'Grandir',
        shrink: 'Reduire',
        'fade-in': 'Fondu',
        'fade-out': 'Eteindre',
        'fade-up': 'Vers le haut',
        'fade-down': 'Vers le bas',
        'fade-left': 'Vers la gauche',
        'fade-right': 'Vers la droite',
        'zoom-in': 'Zoom avant',
        'zoom-out': 'Zoom arriere',
        without_animation: 'sans animation',
        without_transition: 'sans transition',
        convex: 'convexe',
        strike: 'Barré',
        'reveal-text': 'Révélation',
      },
    },
    add_generic: {
      title: 'Sélectionner une vidéo de générique de',
      subtitle: "Veuillez ajouter une vidéo de générique pour terminer l'enregistrement du projet",
      btn_add: 'Ajouter',
      start: 'début',
      end: 'fin',
    },
  },
  disposition: {
    segment: 'Segment',
    disposition: 'Disposition',
    add: 'Ajouter la disposition courante',
    name: 'Nom de la disposition',
    empty: 'Disposition vierge',
  },
  screens: {
    select: 'Séléctionner un écran',
    empty: 'Ecran vierge',
    screen: 'Écran',
  },
  labels: {
    duration: 'Durée',
    direction: 'Direction de la transition',
    transition: 'Type de transition',
    add_model: 'Ajouter un nouveau modèle',
    add_models: 'Ajouter modèle',
    models: 'Modèles',
    images: 'Images',
    videos: 'Vidéos',
    recent: 'Récents',
    title: 'Titre',
    ligne: 'Ligne',
    edit_template_name: 'Veuillez modifier le nom de votre Template:',
    add_template_name: 'Donner un nom à votre Template:',
    Foreground: 'Premier plan',
    advance_more: 'Avancer plus',
    background: 'Arrière plan',
    Recede_less: 'Réculer moins',
    press: 'Appuyez sur ',
    exit_fullScreen: 'pour quitter le plein écran',
    no_models: 'Pas Modèles',
    no_images: 'Pas Images',
    no_videos: 'Pas Vidéos',
    'text-add': 'Ajouter',
  },
  placeholder: {
    search: 'Rechercher..',
    title: 'Titre...',
    describe_problem: 'Décrivez le problème',
    template_title: 'Titre de template',
    ligne: 'Nouvelle ligne',
  },
  titles: {
    send_comment: 'Envoyer des commentaires',
    title_transition: 'Liste des transitions entre les diapositives',
  },
  texts: {},
  template: {
    add_name: 'Donner un nom à votre template:',
    name: 'Nom de la template',
    save_template: 'Enregistrer la template',
    save_as_template: 'Enregistrer une copie de template',
    save_as_copie: 'Enregistrer une copie',
    save_as_video: 'Publier',
    save_and_exit: '  Enregistrer et quitter',
    new_template: 'Nouveau programme',
    new_ligne: 'Nouvelle ligne',
    reclamation: 'Réclamation',
  },
  tooltips: {
    'sw-visibility': 'Affiche les bordures',
    preview: 'Aperçu',
    fullscreen: 'Plein écran',
    'preview-screens': 'Visualisation des écrans',
    'export-template': 'Exporter',
    undo: 'Annuler',
    redo: 'Refaire',
    'gjs-open-import-webpage': 'Importer',
    'canvas-clear': 'Nettoyer canvas',
    'open-sm': 'Gestionnaire de style',
    'open-layers': 'Layers',
    'open-blocks': 'Blocs',
    save: 'Enregistrer',
    'save-template': 'Enregistrer',
    move: 'Déplacement',
    duplicate: 'Dupliquer',
    delete: 'Supprimer',
    setting: 'Paramètres',
    edit: 'Modifier',
  },
  blocks: {
    column1: 'Une colonne',
    column2: 'Deux colonnes',
    column3: 'Trois colonnes',
    'column3-7': 'Deux colonnes 3/7',
    custom_column2: 'Deux colonnes',
    filet: 'Séparateur',
    text: 'Texte',
    link: 'Lien',
    image: 'Image',
    image_media: 'Image',
    video: 'Video',
    map: 'Carte',
    'h-navbar': 'Navbar',
    countdown: 'Compte à rebours',
    form: 'Formulaire',
    input: 'Input',
    textarea: 'Textarea',
    select: 'Selection',
    button: 'Bouton',
    label: 'Label',
    checkbox: 'Checkbox',
    radio: 'Radiobox',
    select_video: 'Sélectionner une vidéo',
    select_image: 'Sélectionner une image',
    drop_files: 'Déposer les fichiers ici ou cliquer pour télécharger',
    select_screen: 'Sélectionner un ou plusieurs écrans',
    select_new: 'Sélectionner un média',
    add_generic_debut: 'générique début ',
    add_generic_fin: 'générique fin ',
    add_generic_intro: "Vidéo d'introduction ",
    preview_screens: 'Visualisation des écrans',
    'link-block': 'Bloc des liens',
    quote: 'Citation',
    'text-basic': 'Texte Basique',
    'lory-slider': 'Lory Slider',
    playlist: 'Playlist',
    Weather: 'Météo',
    Clock: 'Horloge',
    facebook_widget: 'Facebook',
    linkedin_widget: 'LinkedIn',
    rss_widget: 'RSS',
    ticker: 'Téléscripteur',
    web_widget: 'Web',
    webrtc_widget: 'WebRtc',
    player: 'Player',
    video_mp4: 'Player mp4',
    live: 'Direct',
    generic_begin: 'Générique Debut',
    generic_end: 'Générique Fin',
    'social-icons-twitter': 'Twitter',
    Basic: 'Basique',
    Extra: 'Extra',
    Forms: 'Formlaires',
    Widget: 'Widgets',
    Pattern: 'Pattern',
    Media: 'Média',
    column: 'Colonne',
    Tides: 'Marées',
    endText: 'Expiré',
    labelDays: 'Jours',
    labelHours: 'Heures',
    labelMinutes: 'Minutes',
    labelSeconds: 'Secondes',
    dateHeure: 'Date et Heure',
    Text: 'Texte',
    Areas: 'Zones',
    Medias: 'Médias',
    Social: 'Réseaux sociaux',
    Disposition: 'Disposition',
    Dimension: 'Dimension',
    Spacing: 'Espacement',
    Decoration: 'Décoration',
    Background: 'Arrière-plan',
    Border: 'Bordure',
    Responsive: 'Responsive',
    params: 'Paramètres avancés',
    social_media: 'Médias',
    'social-media': 'Sélectionner un média',
    'image-media': 'Sélectionner une image',
    'select_image-media': 'Sélectionner une image',
    select_pattern: 'Sélectionner un motif',
    'custom-title': 'Bloc titre',
    'custom-sharing': 'Bloc partage',
    'custom-credit': 'Bloc crédit',
    pattern: 'Pattern',
    'custom-countdown': 'compte à rebours',
  },
  'display-tides-plugin': {
    tides: 'Marées',
    title: 'Titre',
    lat: 'Latitude',
    lng: 'Longitude',
    start: 'Debut',
    end: 'Fin',
    airTemperature: 'Température de lair',
    humidity: 'Humidité',
    cloudCover: 'Couverture nuageuse',
    currentDirection: 'Direction actuelle',
    currentSpeed: 'Vitesse actuelle',
    precipitation: 'Précipitation',
    swellDirection: 'Direction de houle',
    swellHeight: 'Hauteur de houle',
    swellPeriod: 'Période de houle',
    waterTemperature: 'Température de leau',
    waveDirection: 'Direction des vagues',
    waveHeight: 'Hauteur des vagues',
    wavePeriod: 'Période de vague',
    windWaveDirection: 'Direction des vagues de vent',
    windWaveHeight: 'Hauteur des vagues de vent',
    windWavePeriod: 'Période des vagues de vent',
    seaLevel: 'Niveau de la mer',
    windDirection: 'Direction du vent',
    windSpeed: 'Vitesse du vent',
    gust: 'Rafale',
  },
  'display-weather-plugin': {
    city: 'Ville',
    title: 'Température sur',
    current: 'Courant',
  },
  clock_plugin: {
    title_clock: 'Date et heure',
    sunday: 'Dimanche',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Aout',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Decembre',
  },
  'display-clock-plugin': {
    title_clock: 'Date et heure',
    sunday: 'Dimanche',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Aout',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Decembre',
  },
  'display-dateHeure-plugin': {
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Aout',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Decembre',
  },
  'display-player-plugin': {
    select_new: 'Sélectionner un média',
    placeholder: 'Chercher une video..',
  },
  'display-ticker-plugin': {
    loading: 'Chargement...',
    save: 'Enregistrer',
    modalTitle: 'Entrer votre texte ligne par ligne',
  },
  'display-image-plugin': {
    'select_image-media': 'Sélectionner une image',
    // placeholder: 'Chercher une video..',
  },
  'display-pattern-plugin': {
    select_pattern: 'Sélectionner un motif',
    // placeholder: 'Chercher une video..',
  },
  'display-countdown-plugin': {
    sunday: 'Dimanche',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Aout',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Decembre',
    model: 'Modéle',
    startfrom: 'Date cible',
    hourfrom: 'Temps cible (HH:MM)',
    showStartDate: 'Afficher la date de début',
    source: 'Choisir le format',
    startText: 'Texte de début',
    endText: 'Expiré',
    endPosition: 'Après',
    startPosition: 'Avant',
    countdown1: 'Compte à rebours 1',
    countdown2: 'Compte à rebours 2',
    countdown3: 'Compte à rebours 3',
    labelDays: 'Jours',
    labelHours: 'Heures',
    labelMinutes: 'Minutes',
    labelSeconds: 'Secondes',
    formJours: 'Jours',
    formHeures: 'Heures',
    formMinutes: 'Minutes',
    formSecondes: 'Secondes',
    textBefore: 'Avant',
    textAfter: 'Après',
  },
  message: {
    pageNotFound: "Rien n'a été trouvé",
    copy: 'copie',
  },
  empreinte:
    " distribue une ligne complète de solution vidéo: LIVE RICHMEDIA, WEBTV, L'AFFICHAGE Intranet",
  past_css: 'Coller votre code HTML/CSS et cliquer sur Importer',
  biblioSegment: {
    title: 'Titre',
    theme: 'Thèmes',
    'placeholder-title': 'Nouveau segment',
    selectTheme: 'Selectionner un ou plusieurs thèmes..',
    selectOneTheme: 'Selectionner un thème..',
    description: 'Description',
    addDescription: "Ajout d'une description...",
    author: 'Auteur',
    selectAuthor: 'Selectionner un auteur..',
    Keyword: 'Mots clés',
    addkeyword: 'Ajouter un tag',
    trySearch: "Essayez d'utiliser d'autres termes et options de recherche",
    textDelete: 'Le segment sélectionné est supprimé',
    textAdd: 'Remplir les informations du segment selon les critères mentionnés ci-dessous',
    addSegment: "Ajout d'un segment",
    textEdit: 'Modifier les informations du segment selon les critères mentionnés ci-dessous',
    editSegment: "Modification d'un segment",
    noSearch: 'Aucun segment ne correspond à votre recherche',
    allSegments: 'Tous les segments',
    addTitle: "Ajout d'un Titre",
    noResult: 'La liste est vide..',
    noOption: 'Aucun élément trouvé.',
  },

  addProgram: {
    textAddLine: 'Ajouter un titre et le numéro de la ligne',
    textAdd: 'Ajouter un titre',
    add: 'Créer un nouveau programme',
  },
  sizeCanvas: "Adapté à l'écran",
  module: {
    timeline: {
      title: 'Sélectionné',
    },
    segment: {
      title: 'Ajouter un segment',
    },
    slide: {
      title: 'Ajouter un écran',
    },
    generic: {
      title: 'Ajouter générique',
      textAdd: 'Sélectionner le ',
      success_add: 'Générique ajouté',
    },
  },
  exitSave: {
    exitEditor: "Quitter l'éditeur",
    exitPage: ' Êtes-vous sûr de vouloir quitter la page?',
  },
  styleManager: {
    color: 'Couleur',
    background: 'Arrière plan',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/fr_FR.js